import { Injectable, TemplateRef,Type } from '@angular/core';
import {
  BsModalRef,
  BsModalService,
  ModalDirective,
  ModalOptions
} from 'ngx-bootstrap/modal';
import { take } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class ModalWrapperService {

  constructor(private modalService: BsModalService) {}

  openTemplate(
    template: TemplateRef<any>,
    config?: ModalOptions
  ): BsModalRef {

    const modalRef = this.modalService.show(template, config);

    this.fixBody();

    return modalRef;
  }


    openComponent(component: Type<any>, config?: ModalOptions): BsModalRef {
    const ref = this.modalService.show(component, config);
    this.fixBody();
    return ref;
  }

  openDirective(modal: ModalDirective): void {
    if (!modal) {
      return;
    }

    modal.show();
    this.fixBody();
  }

  private fixBody(): void {
    document.body.style.overflowY = 'auto';
    document.body.style.paddingRight = '0px';
  }
}
